<template>
  <div>
    <p style="font-size: 18px;margin-bottom: 20px;">日期：{{row.countDay}}</p>
    <el-input :rows="8" type="textarea" v-model="row.remark" placeholder="200字以内" :maxlength="200" style="width:33em;" show-word-limit/>
    <div class="dialog-footer" style="text-align: center">
      <el-button @click.native="cancel" size="medium">关闭</el-button>
      <el-button type="primary" size="medium" @click.native="submit" v-loading="submitLoading">提交</el-button>
    </div>
  </div>
</template>

<script>
import { postFormData } from '@/api/api';
import { addTjDayRemark } from '@/api/url';
export default {
  props: {
    value: Object
  },
  data() {
    return {
      row: this.value.row,
      submitLoading: false
    }
  },
  methods: {
    cancel() {
      this.$emit('close');
    },

    submit() {
      if(!this.row.remark) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '备注内容不能为空',
          type: 'warning'
        });
        return false
      }
      let param = {};
      param['countDay'] = this.row.countDay;
      param['remark'] = this.row.remark;
      postFormData(addTjDayRemark, param).then((data) => {
        let {code,msg} = data;
        if(code == 200){
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'success'
          });
          this.$emit('confirm', param);
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.submitLoading = false;
      })
          .catch(function(response){
            this.submitLoading = false;
          })
    }
  },
  mounted() {

  }
}
</script>

<style>

</style>
